import React, { createContext, useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const CarouselContext = createContext();

export const CarouselProvider = ({ children }) => {
  const [mediaList, setMediaList] = useState([]);
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);

  const updateMediaList = useCallback(newList => {
    setMediaList(newList);
    setSelectedMediaIndex(0);
  }, []);

  const selectMedia = index => {
    if (index >= 0 && index < mediaList.length) {
      setSelectedMediaIndex(index);
    }
  };

  const selectNextMedia = () => {
    selectMedia((selectedMediaIndex + 1) % mediaList.length);
  };

  const selectPreviousMedia = () => {
    selectMedia((selectedMediaIndex - 1 + mediaList.length) % mediaList.length);
  };

  const contextValue = {
    mediaList,
    selectMedia,
    selectedMedia: mediaList[selectedMediaIndex],
    updateMediaList,
    selectNextMedia,
    selectPreviousMedia,
  };

  return <CarouselContext.Provider value={contextValue}>{children}</CarouselContext.Provider>;
};

CarouselProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useCarousel = () => useContext(CarouselContext);
